import { RouteObject } from "react-router-dom";
import RouteProtector from "./RouteProtector";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";

const BeneficiaryPersonHistory = lazyWithReload(
  () =>
    import(
      "src/beneficiary/features/BeneficiaryPersonsHistory/BeneficiaryPersonHistory"
    ),
);
const LegalRepresentativeForm = lazyWithReload(
  () =>
    import(
      "src/beneficiary/features/legalRepresentativeForm/LegalRepresentativeForm"
    ),
);
const ViewBeneficiaryPersons = lazyWithReload(
  () =>
    import(
      "src/beneficiary/features/viewBeneficiaryPersons/ViewBeneficiaryPersons"
    ),
);
const BeneficiaryAcknowledge = lazyWithReload(
  () => import("src/beneficiary/features/acknowledge/BeneficiaryAcknowledge"),
);
const BeneficiaryPersonForm = lazyWithReload(
  () =>
    import(
      "src/beneficiary/features/beneficiaryPersonForm/BeneficiaryPersonForm"
    ),
);
const RepresentativeRequestsHistory = lazyWithReload(
  () =>
    import(
      "src/beneficiary/features/representativeRequestsHistory/RepresentativeRequestsHistory"
    ),
);
const RepresentativesRequestsForChamber = lazyWithReload(
  () =>
    import(
      "src/beneficiary/features/representativesRequestsForChamber/RepresentativesRequestsForChamber"
    ),
);
const BeneficiarySubmitSuccess = lazyWithReload(
  () =>
    import("src/beneficiary/features/submitSuccess/BeneficiarySubmitSuccess"),
);
const ManageRepRequestApplication = lazyWithReload(
  () =>
    import(
      "src/beneficiary/features/ManageApplication/ManageRepRequestApplication"
    ),
);
const BeneficiaryDetails = lazyWithReload(
  () =>
    import("src/beneficiary/features/beneficiaryDetails/BeneficiaryDetails"),
);
const AnalyzeAddRequests = lazyWithReload(
  () =>
    import("src/beneficiary/features/AnalyzeAddRequests/AnalyzeAddRequests"),
);
const AnalyzeSelection = lazyWithReload(
  () => import("src/beneficiary/features/AnalyzeSelection/AnalyzeSelection"),
);
const EmailVerification = lazyWithReload(
  () => import("src/beneficiary/features/EmailVerification/EmailVerification"),
);

export const beneficiaryPaths: RouteObject = {
  path: "/beneficiary",
  children: [
    {
      path: "viewBeneficiaryPersons",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ViewBeneficiaryPersons />
        </RouteProtector>
      ),
    },
    {
      path: "beneficiaryPersonHistory",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <BeneficiaryPersonHistory />
        </RouteProtector>
      ),
    },
    {
      path: "legalRepresentativeForm",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <LegalRepresentativeForm />
        </RouteProtector>
      ),
    },
    {
      path: "beneficiaryPersonForm/:personId",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <BeneficiaryPersonForm />
        </RouteProtector>
      ),
    },
    {
      path: "representativesRequestsHistory",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <RepresentativeRequestsHistory />
        </RouteProtector>
      ),
    },
    {
      path: "acknowledge",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <BeneficiaryAcknowledge />
        </RouteProtector>
      ),
    },
    {
      path: "submitSuccess",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <BeneficiarySubmitSuccess />
        </RouteProtector>
      ),
    },
    {
      path: "representativesRequestsForChamber",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <RepresentativesRequestsForChamber />
        </RouteProtector>
      ),
    },
    {
      path: "manageApplication/:id",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ManageRepRequestApplication />
        </RouteProtector>
      ),
    },
    {
      path: "beneficiaryDetails/:id",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <BeneficiaryDetails />
        </RouteProtector>
      ),
    },
    {
      path: "analyzeSelection",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <AnalyzeSelection />
        </RouteProtector>
      ),
    },
    {
      path: "analyzeAddRequests",
      element: (
        <RouteProtector allowedUsers={["isSystemAdmin"]}>
          <AnalyzeAddRequests />
        </RouteProtector>
      ),
    },
    {
      path: "emailVerification",
      element: <EmailVerification />,
    },
  ],
};